import React, { Component } from 'react';
import {Electroentry, Electrotable, Uso, ElMeterCell } from '../entries';
import {WithModal} from '../';
import styles from './style.css';


var epars=["tc_6_97_15", "tc_6_97_14", "tc_6_97_1", "tc_6_97_3", "tc_6_115_3",
    "tc_6_112_3", "tc_6_118_3", "tc_6_97_11", "tc_6_97_12", "tc_6_97_5",
    "tc_6_97_6", "tc_6_97_7", "tc_6_97_8", "tc_6_97_9", "tc_6_97_10",
    "tc_6_97_16", "tc_6_97_13", "tc_6_97_4"];

export default class Electro extends WithModal {

    render() {
        return (
            <div className={[this.props.className,'row col-md-12', styles.App].join(' ')} >
                <Electroentry {...this.props} canvas_id={styles.canvas1} ps={epars}  />
                <Electrotable {...this.props} div_id={styles.canvas2} openModal={this.openModal.bind(this)}/>
                    <Uso {...this.props} ps={['tc_6_93_0']} direction="left" caption="PI" div_id={styles.canvas32}/>
                    <ElMeterCell {...this.props} ps={['ti_6_93_104']} div_id={styles.canvas42}/>

                { (()=> {
                    return super.render();
                })()
                }

                <div className={styles.capt+' '+styles.capt1}>QF2</div>
                <div className={styles.capt+' '+styles.capt29}>QF1</div>
                <div className={styles.capt+' '+styles.capt2}>QF4</div>
                <div className={styles.capt+' '+styles.capt3}>KM1</div>
                <div className={styles.capt+' '+styles.capt4}>KV1</div>
                <div className={styles.capt+' '+styles.capt5}>QF6</div>
                <div className={styles.capt+' '+styles.capt6}>QF7</div>
                <div className={styles.capt+' '+styles.capt7}>QF8</div>
                <div className={styles.capt+' '+styles.capt8}>QF9</div>
                <div className={styles.capt+' '+styles.capt9}>QF10</div>
                <div className={styles.capt+' '+styles.capt10}>QF12</div>
                <div className={styles.capt+' '+styles.capt11}>QF13</div>
                <div className={styles.capt+' '+styles.capt12}>KM3</div>
                <div className={styles.capt+' '+styles.capt13}>KM4</div>
                <div className={styles.capt+' '+styles.capt14}>AB</div>
                <div className={styles.capt+' '+styles.capt15}>KM</div>
                <div className={styles.capt+' '+styles.capt16}>AB</div>
                <div className={styles.capt+' '+styles.capt17}>KM</div>
                <div className={styles.capt+' '+styles.capt31}>AB</div>
                <div className={styles.capt+' '+styles.capt32}>KM</div>
                <div className={styles.capt+' '+styles.capt18}>KM2</div>
                <div className={styles.capt+' '+styles.capt19}>QF5</div>
                <div className={styles.capt+' '+styles.capt20}>KV2</div>
                <div className={styles.capt+' '+styles.capt21}>H-1</div>
                <div className={styles.capt+' '+styles.capt22}>H-2</div>
                <div className={styles.capt+' '+styles.capt23}>EK-3. ТЕРЕН-100</div>
                <div className={styles.capt+' '+styles.capt24}>EK-1. ТЕРЕН-100</div>
                <div className={styles.capt+' '+styles.capt30}>EK-2. ТЕРЕН-20</div>
                <div className={styles.capt+' '+styles.capt25}>Вентиляция 1</div>
                <div className={styles.capt+' '+styles.capt26}>Вентиляция 2</div>
                <div className={styles.capt+' '+styles.capt27}>ЩЛАСМУ</div>
                <div className={styles.capt+' '+styles.capt28}>Теплосчетчик</div>
              
                <div className={"row"}>
                    <div className={"col-md-12 screenText"}>
                        <p>Страница автоматизированного рабочего места (АРМ) «Электрическая» в реальном времени отображает информацию о состоянии основного электрооборудования узла электроиндукционного нагрева автоматизированного (ВЕНА).</p>
                        <p>Для просмотра показателей в виде графика за прошедший период наведите курсор на интересующий Вас показатель и, при появлении символа <i className="fa fa-hand-pointer-o"></i> ,  нажмите на левую кнопку мыши.</p>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Electro/index.jsx